const openModalFastShop = (id) => {
  resetPriceBand();
  clearFastshopResume();
  const modalElement = document.getElementById(`modal--${id}`)
  modalElement.classList.add('visible-modal')
  document.body.classList.add('no-scroll');
}

function handleScrollSectionIntoView(id, sectionId){
  const element = document.getElementById(`productSelectSection--${Number(id)+1}--${sectionId}`);
  if(element != null){
    element.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
  }
}

function closeModal(id){
  resetPriceBand();
  resetResumeList()
  const currentVisibleModal = document.getElementById('modal--' + id)
  currentVisibleModal.classList.remove('visible-modal')
  document.body.classList.remove('no-scroll');
  resetSelectedCounter();
}

function formatCurrency(value) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });
  return formatter.format(value / 100);
}

function handleSubtotalSetter(operationType, price, quantityMultiplier, sectionId, maxGlobalQtd) {
  const currentSubtotalElement = document.querySelector('.order-subtotal--' + sectionId);
  if (currentSubtotalElement != null) {
    const currentSubtotal = currentSubtotalElement.innerHTML
      .split('R$&nbsp;')[1]
      .split(',')
      .join('')
      .split('.')
      .join('');
    let newValue = 0;
    if (operationType === 'plus') {
      newValue = Number(currentSubtotal) + Number(price) * quantityMultiplier;
    } else if (currentSubtotal > 0) {
      newValue = Number(currentSubtotal) - Number(price) * quantityMultiplier;
    }
    currentSubtotalElement.innerHTML = formatCurrency(newValue);
    publish(PUB_SUB_EVENTS.fastshopUpdate,{ source: 'fastshop', data: {sectionId} })
    verifyShowUpsellPromo(newValue);
  }
  handleGlobalQuantitySetter(sectionId, maxGlobalQtd, operationType);     
}

async function handleGlobalQuantitySetter(sectionId, maxGlobalQtd, operationType) {
  await setTimeout(() => {
    const allProductsQtd = document.querySelectorAll('.input-product-qtd--' + sectionId);
    const qtdCircle = document.querySelector('.qtd-circle--' + sectionId);
    let globalQuantity = 0;
    if (allProductsQtd != null) {
      allProductsQtd.forEach((element) => {
        const variantId = element.name.split('_')[1];
        const quantityMultiplier = document.querySelector(`.quantity_multiplier_${variantId}`).value

        globalQuantity += Number(element.value) * Number(quantityMultiplier);
      });
    }
    if (qtdCircle != null) {
      qtdCircle.innerHTML = globalQuantity;
    }
  }, 100);
  validateAllPack(sectionId, maxGlobalQtd, operationType)
}

async function handleMountAndGoCheckout(sectionId, maxGlobalQtd) {
  if(validateAllPack(sectionId, maxGlobalQtd, 'plus')){
    let baseUrl = '/cart/';
    const productArray =  {items:[]};
    const allProductsQtd = document.querySelectorAll('.input-product-qtd--' + sectionId);
    if (allProductsQtd != null && allProductsQtd.length) {
      allProductsQtd.forEach((element) => {
        if (element.value > 0) {
          const variantId = element.name.split('_')[1];
          const quantityMultiplier = document.querySelector(`.quantity_multiplier_${variantId}`).value
          const currentQuantity = element.value * Number(quantityMultiplier);
          productArray.items.push({id:variantId, quantity:currentQuantity});
        }
      });
    }

    await clearCart();
    const goCheckoutBtn = document.getElementById('goCheckoutBtn--' + sectionId);

    if(goCheckoutBtn != null){
      goCheckoutBtn.disabled = true;
      goCheckoutBtn.classList.add('disabledForced');
      goCheckoutBtn.innerHTML = "<span style='width: 20px; height:20px;' class='loader'></span>"
    }
    await addToCartPack(productArray);
  }else {
    const packContainer = document.querySelector('.campaign-packs')
    scrollToElementWithOffset(packContainer, -120)
  }
}

async function addToCartPack(items) {
  const url = 'https://www.caffeinearmy.com.br/cart/add.js';

  await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(items),
  }).then(response => {
    setTimeout(() =>  window.location.href='/checkout', 2000)
  }).catch((error) => {
    if(goCheckoutBtn != null){
       goCheckoutBtn.disabled = false;
      goCheckoutBtn.innerHTML = "Ocorreu um erro ao atualizar o carrinho";
    }
    console.error('Error:', error);
  });
}

async function clearCart(items) {
  const url = 'https://www.caffeinearmy.com.br/cart/clear.js';

  await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
  }).then(response => {
    return true;
  }).catch((error) => {
    console.error('Error:', error);
  });
}


function validateProductBlock(sectionId, maxQtd, operationType){
  const quantityInputs = document.querySelectorAll(`#quantity--${sectionId}`)
  const quantityMultiplier = document.getElementById(`quantity_multiplier--${sectionId}`)
  const blockImages = document.querySelectorAll(`.product-item-card--${sectionId}`)
  let blockCount = 0;
  if(quantityInputs != null && quantityInputs.length > 0){
    quantityInputs.forEach(element => {
      blockCount += Number(element.value);
    })
  }
  if(operationType == 'plus' && blockCount >= maxQtd -1){
   asyncValidateProductBlock(blockImages);
  }else{
    blockImages.forEach(element => element.classList.remove('grayscale-disabled'));      
  }
  return blockCount < maxQtd;
}

function asyncValidateProductBlock(blockImages){
  setTimeout(() => {
    blockImages.forEach(element => {
      const innerDivInput = element.querySelector('.card-info .quantity-box input') 
      if (innerDivInput && innerDivInput.value > 0) {
        element.classList.remove('grayscale-disabled')
      }else{
        element.classList.add('grayscale-disabled')
      }          
    });
  }, 100);
}

function validateAllPack(sectionId, maxQtdGlobal, operationType){
  const globalQuantity = document.querySelector('.qtd-circle--'  + sectionId);
  const globalMaxQuantity = maxQtdGlobal
  const buttonDisabled = document.querySelector('.buttonCheckout--' + sectionId);
  if(globalQuantity.innerHTML >= globalMaxQuantity -1 && operationType == 'plus'){
    buttonDisabled.classList.remove('disabledForced')
  }else if(globalQuantity.innerHTML <= globalMaxQuantity) {
    buttonDisabled.classList.add('disabledForced')
  }

  return globalQuantity.innerHTML >= globalMaxQuantity;
}

function resetSelectedCounter() {
  const productCards = document.querySelectorAll('.product-item-card');
  const subtotals = document.querySelectorAll('#order-subtotal');
  const qtdCircles = document.querySelectorAll('.qtd-circle');
  if(productCards != null && subtotals != null && qtdCircles != null){
    subtotals.forEach(subtotal =>  subtotal.innerHTML = 'R$&nbsp;0,00');
    qtdCircles.forEach(qtdCircle => qtdCircle.innerHTML = 0);
      productCards.forEach(card => {
        card.classList.remove('grayscale-disabled');
        card.dispatchEvent(new CustomEvent('reset-count'));
      });
  }
}

function scrollToElementWithOffset(element, offset) {

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementPosition + offset;

  setTimeout(() => {
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }, 400);
}

function resetResumeList(){
  const fastShopResumeListElements = document.querySelectorAll(`.fastshop-resume-list`);
  fastShopResumeListElements.forEach(element => element.innerHTML = '');
}

function toggleResumeVisibility(id){
  const resumeSection = document.querySelector(`.fastshop-resume-section--${id}`);
  const buttonsResumeSpan = document.querySelectorAll(`.button-toggle--${id} span`);
  const fastShopResumeListElement = document.getElementById(`fastshop-resume--${id}`);
  if (fastShopResumeListElement != null && buttonsResumeSpan != null){
    fastShopResumeListElement.classList.toggle('hidden')
    buttonsResumeSpan.forEach(element => element.classList.toggle('hidden'))
    resumeSection.classList.toggle('items-start')
  }
  calculateAndSetPaddingBottom(id)
}

function mountFastshopResume(id){
  setTimeout(() => {
    const resumeSection = document.querySelector(`.fastshop-resume-section--${id}`);
    const productList = fastshopResume.getCurrentProductList();
    const fastShopResumeListElement = document.getElementById(`fastshop-resume--${id}`);
    fastShopResumeListElement.innerHTML = '';
    if(productList != null && productList.length != 0){
      resumeSection.classList.remove('hidden');
      productList.forEach(item => {
        const priceFormated = formatCurrency(item.price);
        fastShopResumeListElement.innerHTML += `
        <li class="fastshop-product-item">
          <span>${item.title}</span>
          <span data-fullprice='${item.price}' id="fastShopListItemPrice">${priceFormated}</span>
        </li>
        `
      })
    }else if(productList.length === 0){
      resumeSection.classList.add('hidden');
    }
  }, 500)
}

function setProductImage(id){
  const lastProductOnList = fastshopResume.getCurrentProductList().at(-1);
  const iconProduct = document.getElementById(`icon-product--${id}`)
  if(iconProduct != null && lastProductOnList != null){
    iconProduct.src = lastProductOnList.images[0]
  }
}

function handleFastshopResumeVisuals(id){
  mountFastshopResume(id)
  setProductImage(id)
}

function  calculateAndSetPaddingBottom(id){
  const productContainer = document.querySelector(`.product-container--${id}`);
  const fixedBottomBar = document.querySelector(`.fixed-bottom-bar--${id}`)
  const paddingOffset = fixedBottomBar.offsetHeight + 15
  if(productContainer != null && fixedBottomBar != null){
    productContainer.style.paddingBottom = `${paddingOffset}px` ;
  }
}

function goToUpsell(){
  const upsellFastShop = document.getElementById('upsell-binded');
  upsellFastShop.classList.remove('hidden');
  scrollToElementWithOffset(upsellFastShop, -50);
}

function verifyShowUpsellPromo(moneyInCents){
  const upsellFastShop = document.querySelector('.fastshop-upsell-card');
  if(moneyInCents >= 27000 && upsellFastShop != null){
    upsellFastShop.classList.remove('hidden');
  }
}